const DataType = {
    TEXT: 1,
    INT: 2,
    DOUBLE: 3,
    DATE: 4,
    DATE_TIME: 5,
    BOOLEAN: 6,
    BUTTON: 7,
    TEXTAREA: 8,

    PASSWORD: 9,
    SELECT: 10,
    MULTI_SELECT: 11
};

export default DataType;